export default "__VITE_ASSET__DrcbXlmb__"